import { collection, doc, QueryDocumentSnapshot } from "firebase/firestore";

import { db } from "~/integrations/firebase/firestore";

export type OnixImportReportExportStatus =
  | "pending"
  | "processing"
  | "completed"
  | "failed";

export interface OnixImportReportExport {
  id: string;
  organisationId: string;
  userId: string;
  onixImportReportId: string;
  createdAt: string;
  updatedAt: string;
  status: OnixImportReportExportStatus;
  storagePath?: string;
  storageUrl?: string;
  totalChunks?: number;
  error?: string;
}

type OnixImportReportExportFromFirebase = Omit<OnixImportReportExport, "id">;

const onixImportReportExportConverter = {
  toFirestore: (report: OnixImportReportExport) => {
    // biome-ignore lint/correctness/noUnusedVariables: drops id before the document is written to Firestore
    const { id, ...rest } = report;
    return rest;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot<OnixImportReportExportFromFirebase>,
  ): OnixImportReportExport {
    const data = snapshot.data();

    return {
      ...data,
      id: snapshot.id,
    };
  },
};

export const getOnixImportReportsCollection = () =>
  collection(db, "onixImportReports").withConverter(
    onixImportReportExportConverter,
  );

export const getOnixImportReportDocument = (id: string) =>
  doc(db, "onixImportReports", id).withConverter(
    onixImportReportExportConverter,
  );
